var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClear = function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    style: {
      stroke: "currentColor"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.078 10.14 3.359 3.423M3.36 10.14l6.718-6.718"
  }))));
};
export { SvgClear as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMTQgMTQiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHN0eWxlPgogICAgICAgIGcgeyBzdHJva2U6IGN1cnJlbnRDb2xvcjsgfQogICAgPC9zdHlsZT4KICAgIDxnIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgPHBhdGggZD0ibTEwLjA3NzkgMTAuMTQwNi02LjcxODY0LTYuNzE4NTkiLz4KICAgICAgICA8cGF0aCBkPSJtMy4zNTkyNSAxMC4xNDA2IDYuNzE4NjUtNi43MTg1OSIvPgogICAgPC9nPgo8L3N2Zz4=";